module.exports = __webpack_public_path__ + "static/media/16-18.8a71e899.mp3";